// extracted by mini-css-extract-plugin
module.exports = {"projects":"Projects_projects__32qAd","active":"Projects_active__1c2U0","tabs":"Projects_tabs__2IW0i"};